import Router from './routes';
import { ConfigProvider } from 'antd';

function App() {
  return (
    <ConfigProvider theme={{
      token: {
        colorPrimary: '#FFB347',
        sidbarBackground: '#f7f7f7',
        colorBgLayout:'#FFF',
        colorBorder:'#FFB347'
      }
    }}>
        <Router />
    </ConfigProvider>

  );
}

export default App;
